import React from 'react';

export default class TipaltiEvaluatorDataItem {
  constructor(item) {
    if (item === undefined) {
      this.ErrorMessage = '';
      this.Alias = '';
      this.CompanyName = '';
      this.ExternalID = '';
      this.ApAccountExternalId = '';
      this.PaymentTermId = '';
      this.TaxFormSubmittedBy = '';
      this.TaxFormType = '';
      this.TaxFormEntityName = '';
      this.TaxFormEntityType = '';
      this.PortalUser = '';
      this.TaxFormStatus = '';
      this.EntityType = '';
      this.Idap = '';
      this.ActualPayerEntity = '';
      this.PreferredPayerEntity = '';
      this.StatusUpdateDate = '';
      this.StatusReason = '';
      this.Status = '';
      this.Payable = '';
      this.PaymentCurrency = '';
      this.Phone = '';
      this.Country = '';
      this.State = '';
      this.City = '';
      this.Street2 = '';
      this.Street1 = '';
      this.PaymentMethod = '';
      this.LastName = '';
      this.MiddleName = '';
      this.FirstName = '';
      this.Email = '';
      this.ZipNumber = '';
    } else {
      this.ErrorMessage = item.errorMessage;
      this.Alias = item.alias;
      this.CompanyName = item.companyName;
      this.ExternalID = item.externalID;
      this.ApAccountExternalId = item.apAccountExternalId;
      this.PaymentTermId = item.paymentTermId;
      this.TaxFormSubmittedBy = item.taxFormSubmittedBy;
      this.TaxFormType = item.taxFormType;
      this.TaxFormEntityName = item.taxFormEntityName;
      this.TaxFormEntityType = item.taxFormEntityType;
      this.PortalUser = item.portalUser;
      this.TaxFormStatus = item.taxFormStatus;
      this.EntityType = item.entityType;
      this.Idap = item.idap;
      this.ActualPayerEntity = item.actualPayerEntity;
      this.PreferredPayerEntity = item.preferredPayerEntity;
      this.StatusUpdateDate = item.statusUpdateDate;
      this.StatusReason = item.statusReason;
      this.Status = item.status;
      this.Payable = item.payable;
      this.PaymentCurrency = item.paymentCurrency;
      this.Phone = item.phone;
      this.Country = item.country;
      this.State = item.state;
      this.City = item.city;
      this.Street2 = item.street2;
      this.Street1 = item.street1;
      this.PaymentMethod = item.paymentMethod;
      this.LastName = item.lastName;
      this.MiddleName = item.middleName;
      this.FirstName = item.firstName;
      this.Email = item.email;
      this.ZipNumber = item.zipNumber;
    }
  }

  static NameOfTheIdField() {
    return 'EvId';
  }
  static nameOfTheItemDetailList(item) {
    const payableimg = item.Payable === 'True' ? '/img/yes.png' : '/img/no.png';
    return (
      <span>
        Tipalti ID (SassieID): {item.Idap}{' '}
        {/* Todo: Uncomment when TpEvaluators becomes the default for Tipalti integration */}
        {/* Tipalti ID ('Tp_' + TpEvaluatorId): {item.Idap}{' '} */}
        <img
          src={payableimg}
          width='100'
          alt='pnp'
        />
      </span>
    );
  }

  static MoneyFields = [''];

  static Currency() {
    return 'USD';
  }

  static MoneyFieldsSecondary = [''];

  static CurrencySecondary() {
    return 'USD';
  }

  static DateFields = [''];

  static BoolFields = ['Payable'];

  static editFunction = (id, user, userList) => {
    alert('Empty function');
  };

  static FieldsToShowInListTable = [
    {
      tabName: 'PersonalInformation',
      tabLabel: 'Personal Information',
      icon: 'fa-solid fa-tag',
      data: [
        { name: '-', label: 'Personal Information' },
        { name: 'FirstName', label: 'First Name:' },
        { name: 'MiddleName', label: 'Middle Name:' },
        { name: 'LastName', label: 'Last Name:' },
        { name: 'Phone', label: 'Phone Number:' },
        { name: 'Country', label: 'Country:' },
        { name: 'State', label: 'State:' },
        { name: 'ZipNumber', label: 'Zip Code:' },
        { name: 'Street1', label: 'Street:' },
        { name: 'Street2', label: 'Street:' },
        { name: 'Email', label: 'Email:' },
        { name: 'CompanyName', label: 'Company Name:' },
      ],
    },
    {
      tabName: 'TaxInformation',
      tabLabel: 'Tax Information',
      icon: 'fa-solid fa-money-bill-wave',
      data: [
        { name: '-', label: 'Tax Information' },
        { name: 'TaxFormSubmittedBy', label: 'Tax Form Submier:' },
        { name: 'TaxFormType', label: 'Tax Form Type:' },
        { name: 'TaxFormEntityName', label: 'Tax Form Entity Name:' },
        { name: 'TaxFormStatus', label: 'Tax Form Status:' },
        { name: 'PortalUser', label: 'Portal User:' },
        { name: 'EntityType', label: 'Entity Type:' },
      ],
    },
    {
      tabName: 'PaymentInformation',
      tabLabel: 'Payment Information',
      icon: 'fa-solid fa-money-check',
      data: [
        { name: '-', label: 'Payment Information' },
        { name: 'PaymentMethod', label: 'Payment Method:' },
        { name: 'PaymentCurrency', label: 'Payment Currency:' },
        { name: 'PaymentTermId', label: 'Payment Term Id:' },
        { name: 'Payable', label: 'Payable:' },
        { name: 'ActualPayerEntity', label: 'Actual Payer Entity:' },
        { name: 'PreferredPayerEntity', label: 'Preferred Payer Entity:' },
        { name: 'StatusUpdateDate', label: 'Status Update Date:' },
        { name: 'Status', label: 'Status:' },
        { name: 'StatusReason', label: 'Status Reason:' },
      ],
    },
  ];
}
